import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { IceBadgeComponent } from '@app/shared/components/atoms/ice-badge/ice-badge.component';
import { IceCardComponent } from '@app/shared/components/atoms/ice-card/ice-card.component';
import { PriceFormatPipe, PriceType } from '@app/shared/pipes/price-format.pipe';

@Component({
  selector: 'app-mobilephone-header',
  templateUrl: './mobilephone-header.component.html',
  styleUrls: ['./mobilephone-header.component.scss'],
  imports: [IceCardComponent, MatIcon, IceBadgeComponent, PriceFormatPipe],
})
export class MobilePhoneHeaderComponent {
  PriceType = PriceType;

  @Input() image: string;
  @Input() icon: string;
  @Input() title: string;
  @Input() mobilePhoneName: string;
  @Input() mobilePhoneImei: string;
  @Input() insuranceName: string;
  @Input() insurancePrice: number;
}
